<template>
  <div class="details-tab">
    <!-- Tabs navigation -->
    <ul class="nav nav-tabs">
      <li v-for="tab in tabs" :key="tab.name" :class="{ active: tab.isActive }">
        <a href="#" @click="selectTab(tab)">{{ tab.name }}</a>
      </li>
    </ul>
    
    <!-- Tab content -->
    <div class="tab-content">
      <div v-for="tab in tabs" :key="tab.name" v-show="tab.isActive" class="tab-pane">
        <h3>{{ tab.name }}</h3>
        <p>{{ tab.content }}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      tabs: [
        { name: 'Subscription Details', content: 'Details about the subscription...', isActive: true },
        { name: 'Container Info', content: 'Information about the container...', isActive: false },
        { name: 'Last Update', content: 'The last update was received...', isActive: false }
      ]
    }
  },
  methods: {
    selectTab(selectedTab) {
      this.tabs.forEach(tab => {
        tab.isActive = (tab.name === selectedTab.name);
      });
    }
  }
}
</script>

<style scoped>
.nav-tabs {
  margin-bottom: 15px;
}
.nav-tabs .active a {
  color: #555;
  background-color: #fff;
  border: 1px solid #ddd;
  border-bottom-color: transparent;
  cursor: default;
}
.tab-content {
  border: 1px solid #ddd;
  border-top: none;
  padding: 15px;
}
</style>



// WEBPACK FOOTER //
// DetailsTab.vue?34a44ae3